// extracted by mini-css-extract-plugin
export default {"badge":"Badge-module__badge--YHD3l","inner":"Badge-module__inner--VEgQz","text":"Badge-module__text--AxDBx","themed":"Badge-module__themed--kYHGP"};